import gql from 'graphql-tag'

export const COMMENTS = gql`
  query Comments($questionId: Int!) {
    commentsPerQuestion(questionId: $questionId) {
      userId
      userName
      content
      createdAt: i18nDate
      isPrivate: restrict
    }
  }
`

export const CREATE_COMMENT = gql`
  mutation CreateComment($questionId: Int!, $content: String!, $isPrivate: Boolean) {
    createComment(questionId: $questionId, content: $content, isPrivate: $isPrivate) {
      id
    }
  }
`
